export const THEME_CHANGE_TYPE = 'THEME_CHANGE_TYPE';
